export default {
      id: "ic-home-search-usage",
      viewBox: "0 0 23.5 25.5",
      url: "../dist/images/" + "sprite.svg#ic-home-search-usage",
      toString: function () {
        return this.url;
      }
    }